// import React from "react";
// import { SVGMap } from "react-svg-map";
// import india from "@svg-maps/india";

// const IndiaMap = () => {

//   const colors = [
//     "#FF7043",
//     "#66BB6A",
//     "#42A5F5",
//     "#AB47BC",
//     "#FFA726",
//     "#26C6DA",
//     "#EC407A",
//     "#9CCC65",
//     "#5C6BC0",
//     "#FFCA28"
//   ];

//   const getColorClass = (location, index) => {
//     return `state-color-${index % colors.length}`;
//   };

//   const handleClick = (event) => {
//     const state = event.target.getAttribute("name");
//     alert("Clicked: " + state);
//   };

//   return (
//     <div style={{ width: "900px", margin: "auto" }}>

//       <SVGMap
//         map={india}
//         onLocationClick={handleClick}
//         locationClassName={getColorClass}
//       />

//       <style>
//         {`
//         .svg-map__location {
//           stroke: #ffffff;
//           stroke-width: 1;
//           cursor: pointer;
//           transition: 0.3s;
//         }

//         .svg-map__location:hover {
//           opacity: 0.8;
//         }

//         ${colors
//           .map(
//             (color, i) =>
//               `.state-color-${i} { fill: ${color} !important; }`
//           )
//           .join("\n")}
//         `}
//       </style>

//     </div>
//   );
// };

// export default IndiaMap;
// import React from "react";
// import { SVGMap } from "react-svg-map";
// import india from "@svg-maps/india";

// const IndiaMap = () => {

//   const colors = [
//     "#FF7043",
//     "#66BB6A",
//     "#42A5F5",
//     "#AB47BC",
//     "#FFA726",
//     "#26C6DA",
//     "#EC407A",
//     "#9CCC65",
//     "#5C6BC0",
//     "#FFCA28"
//   ];

//   // Filter only Gujarat
//   const gujaratMap = {
//     ...india,
//     locations: india.locations.filter(
//       (loc) => loc.name === "Gujarat"
//     )
//   };

//   const getColorClass = (location, index) => {
//     return `state-color-${index % colors.length}`;
//   };

//   const handleClick = (event) => {
//     const state = event.target.getAttribute("name");
//     alert("Clicked: " + state);
//   };

//   return (
//     <div style={{ width: "900px", margin: "auto" }}>

//       <SVGMap
//         map={gujaratMap}
//         onLocationClick={handleClick}
//         locationClassName={getColorClass}
//       />

//       <style>
//         {`
//         .svg-map__location {
//           stroke: #ffffff;
//           stroke-width: 1;
//           cursor: pointer;
//           transition: 0.3s;
//         }

//         .svg-map__location:hover {
//           opacity: 0.8;
//         }

//         ${colors
//           .map(
//             (color, i) =>
//               `.state-color-${i} { fill: ${color} !important; }`
//           )
//           .join("\n")}
//         `}
//       </style>

//     </div>
//   );
// };

// export default IndiaMap;
import React from "react";
import { SVGMap } from "react-svg-map";
import india from "@svg-maps/india";

const IndiaMap = () => {

  const colors = [
    "#FF7043",
    "#66BB6A",
    "#42A5F5",
    "#AB47BC",
    "#FFA726"
  ];

  const states = [
    "Kerala",
    "Tamil Nadu",
    "West Bengal",
    "Puducherry"
  ];

  const getStateMap = (state) => ({
    ...india,
    locations: india.locations.filter(
      (loc) => loc.name === state
    )
  });

  const handleClick = (event) => {
    const state = event.target.getAttribute("name");
    alert("Clicked: " + state);
  };

  const getColorClass = (index) => {
    return `state-color-${index % colors.length}`;
  };

  return (
    <div style={{ width: "100%", margin: "auto" }}>

      <div className="map-row">

        {states.map((state, index) => (
          <div className="map-box" key={state}>

            <SVGMap
              map={getStateMap(state)}
              onLocationClick={handleClick}
              locationClassName={() => getColorClass(index)}
            />

            <p className="state-title">{state}</p>

          </div>
        ))}

      </div>

      <style>
        {`
        .map-row{
          display:flex;
          justify-content:space-between;
          align-items:center;
          gap:40px;
        }

        .map-box{
          width:100%;
          text-align:center;
        }

        .state-title{
          margin-top:10px;
          font-weight:600;
        }

        .svg-map__location {
          stroke: #ffffff;
          stroke-width: 1;
          cursor: pointer;
          transition: 0.3s;
        }

        .svg-map__location:hover {
          opacity: 0.8;
        }

        ${colors
          .map(
            (color, i) =>
              `.state-color-${i} { fill: ${color} !important; }`
          )
          .join("\n")}
        `}
      </style>

    </div>
  );
};

export default IndiaMap;